/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsServiceDeskCustomerPermissionsType from '@jira/spa-apps__project-settings-service-desk-customer-permissions/src/ServiceDeskCustomerPermissionsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskCustomerPermissions: LazyComponent<
	() => React.JSX.Element
> = lazyForPaint<typeof ProjectSettingsServiceDeskCustomerPermissionsType>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-customer-permissions", jiraSpaEntry: "async-project-settings-service-desk-customer-permissions" */ '@jira/spa-apps__project-settings-service-desk-customer-permissions/src/ServiceDeskCustomerPermissionsPage.tsx'
		),
	),
);

const AsyncProjectSettingsServiceDeskCustomerPermissions = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskCustomerPermissions}
		pageId="project-settings-customer-permissions"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsServiceDeskCustomerPermissions;
